module.exports = __webpack_public_path__ + "img/img_home_banner_job_seeker.9b876aa.png";